import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BrokerFab from '@/components/feature/BrokerFab';

export default function SiteLayout() {
  const location = useLocation();

  useEffect(() => {
    const rawHash = location.hash.replace(/^#/, '');

    if (!rawHash) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      return undefined;
    }

    const timer = window.setTimeout(() => {
      const target = document.getElementById(decodeURIComponent(rawHash));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }
    }, 120);

    return () => window.clearTimeout(timer);
  }, [location.pathname, location.hash, location.key]);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-md focus:bg-primary-500 focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-background-50"
      >
        ข้ามไปยังเนื้อหาหลัก
      </a>
      <SiteHeader />
      <main id="main-content" tabIndex={-1} className="flex-1 focus:outline-none">
        <Outlet />
      </main>
      <SiteFooter />
      <BrokerFab />
    </div>
  );
}